import * as Website from '../../Config/Website.js';
import FvSlider from './modules/FvSlider.js';


const preinit = () => {

}

const init = () => {
  FvSlider();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}